// extracted by mini-css-extract-plugin
export var active = "index-module--active--7HhVd";
export var bottomLogo = "index-module--bottomLogo--i-Ukx";
export var container = "index-module--container--m0TMX";
export var item = "index-module--item--5l4UU";
export var list = "index-module--list--U7tG8";